import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Modal from '@deprecated-ui/common/Modal';
import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import { ORDER_TYPE } from 'constants/trading';
import { clevertapExchangeFee } from 'lib/analytics/securities';
import realTradingStore from 'global/TradingModal/RealTradingModal/store';
import { useEffect } from 'react';
import { FeeItem } from '../../styled';

interface iExchangeFeeModal {
  visible: boolean;
  orderType: string;
  closeModal: () => void;
}

function ExchangeFeeModal({
  visible,
  closeModal,
  orderType,
}: iExchangeFeeModal) {
  const securitiesPreviewFeeData = localStorage.getItem(
    'securitiesPreviewFeeData',
  );
  const securitiesPreviewFeeDataDayTrade = localStorage.getItem(
    'securitiesPreviewFeeDataDayTrade',
  );

  const { dayTradeActive } = realTradingStore();

  const previewFeeData = dayTradeActive
    ? securitiesPreviewFeeDataDayTrade
    : securitiesPreviewFeeData;

  const {
    exchange: {
      title,
      desc,
      subtitle,
      compositions,
      exchange_fee_total_title,
      exchange_fee_total_buy,
      exchange_fee_total_sell,
    },
  } = JSON.parse(previewFeeData) || { exchange: {} };

  const isSell =
    orderType === ORDER_TYPE.AMEND_SELL || orderType === ORDER_TYPE.SELL;

  useEffect(() => {
    if (visible) clevertapExchangeFee(orderType);
  }, [visible]);

  return (
    <Modal
      visible={visible}
      centered
      onCancel={closeModal}
      closable={false}
      width="420px"
    >
      <IconWrapper style={{ position: 'absolute', left: '30px', top: '20px' }}>
        <Iconmoon
          size="25px"
          className="icon-notification_back"
          onClick={closeModal}
        />
      </IconWrapper>
      <Text size="16px" align="center" family="bold" padding="20px">
        {title}
      </Text>
      <Flex direction="column" padding="10px 35px 30px 35px">
        <Text>{desc}</Text>
        {/* @ts-expect-error */}
        <Text mt="10px">{subtitle}</Text>
        <Flex
          direction="column"
          padding="15px"
          // @ts-expect-error
          mt="10px"
          width="100%"
          style={{ border: '1px solid #dadada', borderRadius: '5px' }}
        >
          {compositions.map(({ name, value, type }) => {
            if (type === 3 || isSell) {
              return (
                <FeeItem key={value}>
                  <Text>{name}</Text>
                  <Text>{value}%</Text>
                </FeeItem>
              );
            }

            return null;
          })}
          <FeeItem>
            {/* @ts-expect-error */}
            <Text family="bold" py="8px">
              {exchange_fee_total_title}
            </Text>
            <Text family="bold">
              {(isSell ? exchange_fee_total_sell : exchange_fee_total_buy) *
                100}
              %
            </Text>
          </FeeItem>
        </Flex>
      </Flex>
    </Modal>
  );
}

export default ExchangeFeeModal;
